export default __webpack_public_path__ + "static/iceCream-0ec3bc7cd3fb465dee63ce8060bdcda1.jpg";